var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMediaBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 8.52003L5.91832 2.33333C5.83305 2.28122 5.73544 2.25276 5.63553 2.25089C5.53562 2.24902 5.43701 2.2738 5.34985 2.32268C5.26269 2.37156 5.19013 2.44278 5.13963 2.52901C5.08912 2.61524 5.0625 2.71336 5.0625 2.81329V15.1867C5.0625 15.2866 5.08912 15.3848 5.13963 15.471C5.19013 15.5572 5.26269 15.6284 5.34985 15.6773C5.43701 15.7262 5.53562 15.751 5.63553 15.7491C5.73544 15.7472 5.83305 15.7188 5.91832 15.6667L16.0417 9.47996C16.1239 9.42971 16.1918 9.35919 16.239 9.27514C16.2861 9.1911 16.3109 9.09635 16.3109 8.99999C16.3109 8.90363 16.2861 8.80889 16.239 8.72485C16.1918 8.6408 16.1239 8.57027 16.0417 8.52003Z",
    stroke: "#262D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaBrowser);
export default __webpack_public_path__ + "static/media/MediaBrowser.d6d0aedb37c84719650f84c314e02acb.svg";
export { ForwardRef as ReactComponent };